$shm_showcase_demo_dotsloader $mol_list
	rows /
		<= Enabled $mol_check_box
			title \Загрузка
			checked? <=> loading? true
		^ content
	Loader $shm_dotsloader
